// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  background: #f7f8fa;
  flex: 1;
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
}

header {
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.0509803922) 0 1px 2px, rgba(0, 0, 0, 0.0509803922) 0 1px 4px, rgba(0, 0, 0, 0.0509803922) 0 2px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  padding: 0 15px 0 20px;
}
header img {
  height: 24px;
}
header img.custom {
  height: 32px;
}

.container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin: auto;
  max-width: 999px;
  overflow: auto;
}

.password-prompt {
  width: 320px;
}
.password-prompt .hint {
  color: #777;
  font-size: 13px;
  margin-top: 1em;
  margin-bottom: 0;
}
.password-prompt .mat-form-field {
  width: 100%;
}

.flex-end {
  display: flex;
  justify-content: flex-end;
}

.card {
  background-color: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 5px 10px;
  overflow: hidden;
  position: relative;
}
.card:hover {
  box-shadow: rgba(0, 0, 0, 0.0509803922) 0 1px 2px, rgba(0, 0, 0, 0.0509803922) 0 1px 4px, rgba(0, 0, 0, 0.0509803922) 0 2px 8px;
}
.card img {
  object-fit: contain;
  width: 160px;
  height: 200px;
  margin: 5px;
  transition: 1s opacity;
}
.card .gone {
  opacity: 0;
}
.card .overlay {
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.54) 0%, rgba(0, 0, 0, 0.17) 100%);
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 210px;
  opacity: 0;
}
.card .overlay:hover {
  opacity: 1;
}
.card .overlay .mat-icon {
  color: #fff;
  padding: 6px 8px;
  width: 36px;
  height: 40px;
}
.card .label {
  width: 170px;
  padding: 5px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (min-width: 640px) {
  .card {
    margin: 0 10px 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/dms/etax-shared/etax-shared.component.scss"],"names":[],"mappings":"AAAA;EACG,mBAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;AACH;;AAEA;EACG,sBAAA;EACA,+HAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,sBAAA;AACH;AACG;EACG,YAAA;AACN;AACM;EACG,YAAA;AACT;;AAIA;EACG,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AADH;;AAIA;EACG,YAAA;AADH;AAGG;EACG,WAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AADN;AAIG;EACG,WAAA;AAFN;;AAMA;EACG,aAAA;EACA,yBAAA;AAHH;;AAMA;EACG,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAHH;AAKG;EACG,+HAAA;AAHN;AAMG;EACG,mBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;AAJN;AAOG;EACG,UAAA;AALN;AAQG;EACG,8FAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;EACA,UAAA;AANN;AAQM;EACG,UAAA;AANT;AASM;EACG,WAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAPT;AAWG;EACG,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AATN;;AAaA;EACG;IACG,mBAAA;EAVJ;AACF","sourcesContent":[":host {\n   background: #f7f8fa;\n   flex: 1;\n   display: flex;\n   flex-direction: column;\n   position: fixed;\n   left: 0;\n   top: 0;\n   right: 0;\n   bottom: 0;\n   z-index: 99;\n}\n\nheader {\n   background-color: #fff;\n   box-shadow: #0000000d 0 1px 2px, #0000000d 0 1px 4px, #0000000d 0 2px 8px;\n   display: flex;\n   align-items: center;\n   justify-content: space-between;\n   height: 50px;\n   padding: 0 15px 0 20px;\n\n   img {\n      height: 24px;\n\n      &.custom {\n         height: 32px;\n      }\n   }\n}\n\n.container {\n   display: flex;\n   flex-wrap: wrap;\n   align-items: center;\n   justify-content: center;\n   margin: auto;\n   max-width: 999px;\n   overflow: auto;\n}\n\n.password-prompt {\n   width: 320px;\n\n   .hint {\n      color: #777;\n      font-size: 13px;\n      margin-top: 1em;\n      margin-bottom: 0;\n   }\n\n   .mat-form-field {\n      width: 100%;\n   }\n}\n\n.flex-end {\n   display: flex;\n   justify-content: flex-end;\n}\n\n.card {\n   background-color: #fff;\n   border: 1px solid #e5e5e5;\n   border-radius: 4px;\n   cursor: pointer;\n   display: flex;\n   flex-direction: column;\n   align-items: center;\n   margin: 0 5px 10px;\n   overflow: hidden;\n   position: relative;\n\n   &:hover {\n      box-shadow: #0000000d 0 1px 2px, #0000000d 0 1px 4px, #0000000d 0 2px 8px;\n   }\n\n   img {\n      object-fit: contain;\n      width: 160px;\n      height: 200px;\n      margin: 5px;\n      transition: 1s opacity;\n   }\n\n   .gone {\n      opacity: 0;\n   }\n\n   .overlay {\n      background-image: linear-gradient(to bottom,rgba(0,0,0,.54) 0%,rgba(0,0,0,.17) 100%);\n      position: absolute;\n      left: 0;\n      top: 0;\n      right: 0;\n      height: 210px;\n      opacity: 0;\n\n      &:hover {\n         opacity: 1;\n      }\n\n      .mat-icon {\n         color: #fff;\n         padding: 6px 8px;\n         width: 36px;\n         height: 40px;\n      }\n   }\n\n   .label {\n      width: 170px;\n      padding: 5px;\n      text-align: center;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n   }\n}\n\n@media (min-width: 640px) {\n   .card {\n      margin: 0 10px 20px;\n   }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
